import type { useIMask } from 'react-imask';

type Opts = Parameters<typeof useIMask>[0];

/** Опции маски числа для полей AdditionalFields: пробел как разделитель тысяч, до 4 знаков после запятой, точка/запятая. */
export const additionalFieldsNumberMaskOptions: Opts = {
  mask: Number,
  scale: 4,
  thousandsSeparator: ' ',
  padFractionalZeros: false,
  normalizeZeros: false,
  min: 0,
  max: 9999999999,
  radix: ',',
  mapToRadix: ['.'],
};
